/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React from "react";

import { bem } from "../../../shared/BEM";

/**
 * Component props
 */
export interface INewsEntryComponentProps {
	title: string;
	children: any;
}

/**
 * News
 *
 * @param props Component props
 */
export function NewsEntry(props: INewsEntryComponentProps) {

	const stl = bem("menu-news", "entry");

	return <article className={stl.str}>
		<h3>{props.title}</h3>
		{props.children}
	</article>;

}
